interface Props {
    title: string;
    subtitle?: string;
    icon?: React.ReactNode;
    children?: React.ReactNode;
}

export default function SectionHeader({ title, subtitle, icon, children }: Props) {
    return (
        <div className="flex flex-row items-start gap-2 rounded-tl-xl rounded-tr-xl border-b border-gray-200 bg-white p-2.5 sm:items-center sm:gap-3 sm:p-3">
            {icon && (
                <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#186cb2]/10 text-[#186cb2] sm:h-8 sm:w-8">
                    {icon}
                </div>
            )}
            <div className="min-w-0 flex-1">
                <h1 className="truncate text-xs font-semibold text-gray-800 sm:text-sm">
                    {title}
                </h1>
                {subtitle && (
                    <p className="mt-0.5 text-[10px] leading-relaxed text-gray-500 sm:mt-0 sm:text-xs">
                        {subtitle}
                    </p>
                )}
            </div>
            {children && (
                <div className="flex w-auto shrink-0 items-center justify-end gap-1.5 sm:gap-2">
                    {children}
                </div>
            )}
        </div>
    );
}